export interface ErrorData {
  statusCode: number;
  message: string;
  timestamp: string; // ISO string
  endpoint: string;
  method: string;
  requestData?: unknown;
  type?: string; // e.g., 'HTTP', 'Business'
  contextId?: string; // route or page context identifier
}

export interface ErrorHistory {
  latestError: ErrorData | null;
  errorStack: ErrorData[];
  filteredErrors: ErrorData[];
}

export type ErrorFilterPredicate = (error: ErrorData) => boolean;

export enum ErrorCategory {
  Client = 'Client', // 4xx
  Server = 'Server', // 5xx
  Network = 'Network',
  Unknown = 'Unknown',
}

export function categorizeError(statusCode: number): ErrorCategory {
  if (statusCode >= 500) return ErrorCategory.Server;
  if (statusCode >= 400) return ErrorCategory.Client;
  if (statusCode === 0) return ErrorCategory.Network;
  return ErrorCategory.Unknown;
}
